// extracted by mini-css-extract-plugin
export var carrierTab = "_53-0";
export var carrierTabActive = "_53-1 _53-0";
export var carrierTabInactive = "_53-2 _53-0";
export var carrierTabLabel = "_53-3";
export var carrierTabLabelActive = "_53-4 _53-3";
export var carrierTabLabelInactive = "_53-5 _53-3";
export var carrierTabPercentage = "_53-6";
export var carrierTabPercentageActive = "_53-7 _53-6";
export var carrierTabPercentageInactive = "_53-8 _53-6";
export var carrierTabWinnable = "_53-9";
export var carrierTabWinnableActive = "_53-a _53-9";
export var carrierTabWinnableInactive = "_53-b _53-9";
export var comparisonContainer = "_53-d";
export var missingRateButton = "_53-n";
export var missingRateButtonActive = "_53-o _53-n";
export var missingRateButtonInactive = "_53-p _53-n";
export var missingRateButtonLabel = "_53-q";
export var missingRateButtonLabelActive = "_53-r _53-q";
export var missingRateButtonLabelInactive = "_53-s _53-q";
export var sidebar = "_53-c";
export var strategyButton = "_53-e";
export var strategyButtonActive = "_53-f _53-e";
export var strategyButtonDescription = "_53-k";
export var strategyButtonDescriptionActive = "_53-l _53-k";
export var strategyButtonDescriptionInactive = "_53-m _53-k";
export var strategyButtonInactive = "_53-g _53-e";
export var strategyButtonLabel = "_53-h";
export var strategyButtonLabelActive = "_53-i _53-h";
export var strategyButtonLabelInactive = "_53-j _53-h";
export var unitToggleButton = "_53-t";
export var unitToggleButtonActive = "_53-u _53-t";
export var unitToggleButtonInactive = "_53-v _53-t";
export var unitToggleButtonLabel = "_53-w";
export var unitToggleButtonLabelActive = "_53-x _53-w";
export var unitToggleButtonLabelInactive = "_53-y _53-w";